import { render } from "./detailsObjectContent.vue?vue&type=template&id=eeea6fac&scoped=true"
import script from "./detailsObjectContent.vue?vue&type=script&lang=js"
export * from "./detailsObjectContent.vue?vue&type=script&lang=js"

import "./detailsObjectContent.vue?vue&type=style&index=0&id=eeea6fac&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeea6fac"]])

export default __exports__